import { ModuleWithProviders, NgModule, Optional, SkipSelf } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NotifyService } from './utils';
import { GeneralService, InjectorService } from './data';
import { throwIfAlreadyLoaded } from './guards/module-import.guard';
import { QuoteDayService } from './data/quote-day/quote-day.service';
import { ClosePeriodService } from './data/close-period.service';
import { TypeClosePeriodService } from './data/type-close-period.service';
import { DaysNewsService } from './data/days-news/days-news.service';
import { ScheduleEventsService } from './data/schedule-events/schedule-events.service';
import { PaiService } from './data/pai/pai.service';
import { UserService } from './data/user/user.service';
import { EntityService } from './data/entity/entity.service';
import { DepartmentService } from './data/department/department.service';
import { LanguageService } from './data/language/language.service';
import { RoleTypeService } from './data/role-type/role-type.service';
import { FormValidationService } from './data/form-validation/form-validation.service';
import { SectorService } from './data/sector/sector.service';
import { CurrencyService } from './data/currency/currency.service';
import { CountryService } from './data/country/country.service';
import { StructureOrganizativeTypeService } from './data/structure-organizative-type/structure-organizative-type.service';
import { LabelService } from './data/label/label.service';
import { ExchangeTypeService } from './data/exchange-type/exchange-type.service';
import { EstimateExchangeService } from './data/estimate-exchange/estimate-exchange.service';
import { TimeAllocationConceptService } from './data/time-allocation-concept/time-allocation-concept.service';
import { ProcessTypeService } from './data/process-type/process-type.service';
import { SurveyService } from './data/survey/survey.service';
import { QuestionService } from './data/question/question.service';
import { BusinessUnitService } from './data/business-unit/business-unit.service';
import { ProcessService } from './data/process/process.service';
import { ProfessionalCategoryService } from './data/professional-category/professional-category.service';
import { ExportConfigService } from './data/export-config/export-config.service';
import { FinancialYearService } from './data/financial-year/financial-year.service';
import { MenuService } from './data/menu/menu.service';
import { ActivityService } from './data/activity/activity.service';
import { IdeaService } from './data/idea/idea.service';
import { ResourcesService } from './data/resources/resources.service';
import { BudgetService } from './data/budget/budget.service';
import { TaskService } from './data/task/task.service';
import { AlarmsService } from './data/alarms/alarms.service';
import { TypesStateNodesService } from './data/types-state-nodes/types-state-nodes.service';
import { TimeAllocationService } from './data/time-allocation/time-allocation.service';
import { RecommendationService } from './data/recommendation/recommendation.service';
import { AdditionalProposalService } from './data/additional-proposal/additional-proposal.service';
import { SummaryService } from './data/summary/summary.service';



const DATA_SERVICES = [
    InjectorService,
    GeneralService,
    QuoteDayService,
    ScheduleEventsService,
    DaysNewsService,
    ClosePeriodService,
    TypeClosePeriodService,
    PaiService,
    ClosePeriodService,
    TypeClosePeriodService,
    UserService,
    EntityService,
    DepartmentService,
    LanguageService,
    RoleTypeService,
    FormValidationService,
    SectorService,
    CurrencyService,
    CountryService,
    StructureOrganizativeTypeService,
    LabelService,
    ExchangeTypeService,
    EstimateExchangeService,
    TimeAllocationConceptService,
    ProcessTypeService,
    SurveyService,
    QuestionService,
    BusinessUnitService,
    ProcessService,
    ProfessionalCategoryService,
    ExportConfigService,
    FinancialYearService,
    MenuService,
    ActivityService,
    IdeaService,
    ResourcesService,
    BudgetService,
    TaskService,
    AlarmsService,
    TypesStateNodesService,
    TimeAllocationService,
    AdditionalProposalService,
    RecommendationService,
    SummaryService
]


const UTILS_SERVICES = [
    NotifyService
]

export const CORE_PROVIDERS = [
    ...DATA_SERVICES
];

@NgModule({
    imports: [
        CommonModule,
    ],
    exports: [
    ],
    declarations: []
})
export class CoreModule {
    constructor(@Optional() @SkipSelf() parentModule: CoreModule) {
        throwIfAlreadyLoaded(parentModule, 'CoreModule');
    }

    // static forRoot(): ModuleWithProviders<any> {
    //     return <ModuleWithProviders>{
    //         ngModule: CoreModule,
    //         providers: [...CORE_PROVIDERS, ...UTILS_SERVICES],
    //     };
    // }

    static forRoot(): ModuleWithProviders<CoreModule> {
        return  {
            ngModule: CoreModule,
            providers: [...CORE_PROVIDERS, ...UTILS_SERVICES],
        };
      }
}
